// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/list/GRNFilterBar.jsx
// Module: PPE → Procurement → GRN
//
// Purpose:
// - Filter bar UI for GRN list page
// - Similar structure as IndentFilterBar.jsx
// - Allows filtering by status, date range and search text
// ======================================================================

import React from "react";

const GRN_STATUS = [
  "DRAFT",
  "SUBMITTED",
  "APPROVED",
  "POSTED",
  "CANCELLED",
];

export default function GRNFilterBar({
  filters,
  onChange,
  onSearch,
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 12,
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      {/* SEARCH */}
      <input
        className="form-control"
        style={{ maxWidth: 260 }}
        placeholder="Search GRN no / invoice no"
        value={filters.search}
        onChange={(e) =>
          onChange({
            ...filters,
            search: e.target.value,
          })
        }
      />

      {/* STATUS */}
      <select
        className="form-select"
        style={{ maxWidth: 160 }}
        value={filters.status}
        onChange={(e) =>
          onChange({
            ...filters,
            status: e.target.value,
          })
        }
      >
        <option value="">All Status</option>
        {GRN_STATUS.map((status) => (
          <option key={status} value={status}>
            {status}
          </option>
        ))}
      </select>

      {/* FROM DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.from_date}
        onChange={(e) =>
          onChange({
            ...filters,
            from_date: e.target.value,
          })
        }
      />

      {/* TO DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.to_date}
        onChange={(e) =>
          onChange({
            ...filters,
            to_date: e.target.value,
          })
        }
      />

      {/* SEARCH BUTTON */}
      <button
        className="btn btn-primary"
        onClick={onSearch}
      >
        Search
      </button>
    </div>
  );
}
